// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tenant-container[data-v-0c4e332f] {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
